import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FeatureAppItemModel} from '../../../../generated/core';
import {AuthoringWrapper} from '../../../components/AuthoringWrapper';
import {LegalEntityContextData} from '../../../context/legal/LegalEntityProvider';
import {MapTo} from '../../../infrastructure/compatibility/MapTo';
import {C} from '../../../registries/compatibilty';
import {useSectionVisibility} from '../../../infrastructure/compatibility/useSectionVisibility';
import {FeatureApp} from '../../structure/FeatureApp';
import {FeatureAppContent} from '../sections/FeatureAppContent';

const EMPTY_LABEL = 'S141 Feature App Item';

const InternalFeatureAppItem = observer(function ObservedFeatureAppItem(
    props: FeatureAppItemModel & LegalEntityContextData
): JSX.Element | null {
    const {setVisible} = useSectionVisibility();
    const {anchorId, config, tagTypeBroken} = props;

    return (
        <AuthoringWrapper
            anchorId={anchorId}
            title={EMPTY_LABEL}
            bgColor={AuthoringWrapper.BG_COLOR_SECTION}
            tagTypeBroken={tagTypeBroken}
        >
            {C.isInEditor() && config && (
                <FeatureAppContent path="content" name={config.name} />
            )}
            <FeatureApp
                {...props}
                config={{...config, ssrEnabled: false}}
                elementInViewport={true}
                onHasContentChanged={setVisible}
            />
        </AuthoringWrapper>
    );
});

export const FA_ITEM_RESOURCETYPE =
    'vwa-ngw18/components/editorial/items/featureAppItem';
export const FeatureAppItem = MapTo(
    FA_ITEM_RESOURCETYPE,
    InternalFeatureAppItem
);
